import Text from '@components/atoms/Text/Text'
import PropTypesUtils from '@utils/propTypes'
import PropTypes from 'prop-types'
import c from 'classnames'
import styles from './Step.module.scss'

const Step = ({ available, finished, active, stepNumber, children }) => {
  return (
    <div
      className={c([
        styles.base,
        {
          [styles.active]: active,
        },
      ])}
    >
      <div
        className={c([
          styles.circle,
          {
            'b-brand': available,
            'c-white': available,
            'b-white': !available,
            'c-brand': !available,
          },
        ])}
      >
        {(finished && <i className="icon icon-check" />) || (
          <Text type="h3">
            <div className={styles.stepNr}>{stepNumber}</div>
          </Text>
        )}
      </div>
      <div className={c('c-brand', styles.text)}>
        <Text type="text-s">{children}</Text>
      </div>
    </div>
  )
}

Step.defaultProps = {
  available: false,
  finished: false,
  active: false,
}
Step.propTypes = {
  available: PropTypes.bool,
  finished: PropTypes.bool,
  active: PropTypes.bool,
  stepNumber: PropTypes.number.isRequired,
  children: PropTypesUtils.children.isRequired,
}

export default Step
